<template>
<v-card>
  <ValueView v-if="!edit" :deleteEnabled="true" :editEnable="true" :relatedSchema="relatedSchema"
             :relatedValue="relatedValue" v-on:delete="deleteValue($event)"
             v-on:edit="editValue($event)"/>
  <ValueEdit v-else v-on:close="close($event)" v-on:update="update($event)" :relatedValue="relatedValue" :relatedSchema="relatedSchema"></ValueEdit>
</v-card>
</template>
<script>
import ValueView from "./ValueView"
import ValueEdit from "./ValueEdit"
export default {
  components: {
    ValueEdit,
    ValueView
  },
  props: ['relatedValue', 'relatedSchema'],
  data() {
    return {
      edit: false,
      editModel: {}
    }
  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  methods: {
    editValue() {
      this.edit = true
    },
    close() {
      this.edit = false
    },
    deleteValue(e) {
      this.$emit('delete', e)
    },
    update(editModel) {
      this.$emit('update', {
        'model': editModel,
        'callback': () => this.close()
      })
    }
  }
}
</script>

<style>
</style>
